module.exports = require("@fullcalendar/core");